<template>
    <div class="eq-container">
        <div class="eq-wrap">
            <div class="text-center">
                <b-img :src="info.img" fluid></b-img>
            </div>
            <div class="eq-overlayer">
                <h3>{{info.title}}</h3>
                <p class="mb-0" v-html="info.desc" v-if="desc"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['info', 'desc']
}
</script>

<style lang="scss">
    .eq{
        &-container{
            width: 100%;
            box-shadow: 0px 0px 3px #999;
        }
        &-wrap{
            position: relative;
            overflow: hidden;
            
            &:hover .eq-overlayer{
                top:0;
                bottom: 0;
                transition: all 0.3s;
            }
        }

        &-overlayer{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            position: absolute;
            z-index: 2;
            top: -500px;
            bottom: 100%;
            right: 0;
            left: 0;
            padding: 12px 14px;
            background-color: rgba($color-main,.7);
            color: #fff
        }
    }
</style>